// extracted by mini-css-extract-plugin
module.exports = {"root":"DashboardPayoutSummary_root__6xubL"};